import $ from 'jquery';

import './style.scss';

const COLUMN_EXPANDER_SELECTOR = '.comparison-table__feature--expander';
const ACCORDION_SELECTOR = '.luna-accordion';
const BUTTON_SELECTOR = '.luna-accordion__action';
const ICON_SELECTOR = '.luna-icon use';
const OPEN = 'is-open';
const OPEN_ICON = '#chevron-up';
const CLOSE_ICON = '#chevron-down';

function handleAccordionClick(e) {
  e.preventDefault();
  const $accordion = $(e.target).closest(ACCORDION_SELECTOR);
  const $accordionIcon = $accordion.find(ICON_SELECTOR);
  const isOpen = $accordion.hasClass(OPEN);
  if (isOpen) {
    $accordion.removeClass(OPEN);
  } else {
    $accordion.addClass(OPEN);
  }

  $accordionIcon.attr('xlink:href', isOpen ? CLOSE_ICON : OPEN_ICON);
  $.trackEvent(
    $accordion.attr('data-track-category'),
    $accordion.attr('data-track-action'),
    isOpen ? 'Column Contract' : 'Column Expand',
  );
}

function attachEvent($table) {
  const $expander = $table.find(COLUMN_EXPANDER_SELECTOR);
  if ($expander.length) {
    $expander.find(BUTTON_SELECTOR).on('click', handleAccordionClick);
  }
}

export default function registerColumnExpanderHandlers($table) {
  attachEvent($table);

  $table.on('onLoaded', (e) => {
    attachEvent($(e.target));
  });
}
